import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { secondaryBlue } from '../../../../../utils/color';
import { ReactComponent as BriefcaseCheckIcon } from '../../../../../assets/icons/layout-icons/BriefcaseCheckIcon.svg';
import { Typography } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import CustomButton from '../../../../../components/button/CustomButton';
import useUpdate from '../../../../../utils/hooks/crud-hooks/useUpdate';
import { RejectFirstStepType } from '../../interface';
import { useRefresh } from '../../../../../utils/hooks/crud-hooks/useRefresh';
import { EnumTimedProjectPitchStatus } from 'tdc-web-backend/enums/enums';

const RejectFirstStep = ({ setSliderPage, setIsOpen, pitchId, status }: RejectFirstStepType) => {
  const { mutate: reject } = useUpdate({
    resource: '/timed-project-pitches',
  });

  const { t } = useTranslation();

  const refresh = useRefresh();

  const handleReject = () => {
    reject(
      {
        id: pitchId,
        suffix: 'reject-pitch',
      },
      {
        onSuccess: () => {
          refresh();
          setSliderPage(1);
        },
      },
    );
  };

  return (
    <Stack direction="column">
      <Stack direction="row" alignItems="center" mb={3}>
        <Stack
          width={40}
          height={40}
          mr={2}
          bgcolor="secondaryBlue.100"
          borderRadius={1}
          justifyContent="center"
          alignItems="center"
        >
          <BriefcaseCheckIcon width="20px" fill={secondaryBlue[700]} />
        </Stack>
        <Typography variant="heading4" color="primaryDark.600">
          {t('pitches.modals.reject.firstStep.title')}
        </Typography>
      </Stack>
      <Stack
        py={2}
        sx={{
          borderTop: `1px solid ${secondaryBlue[100]}`,
          borderBottom: `1px solid ${secondaryBlue[100]}`,
        }}
      >
        <Typography color="primaryDark.500" variant="body2">
          {EnumTimedProjectPitchStatus.FirstRound === status
            ? t('pitches.modals.reject.firstStep.firstRound')
            : t('pitches.modals.reject.firstStep.secondRound')}
        </Typography>
      </Stack>
      <Stack gap={0.625} direction="row" justifyContent="center" my={3}>
        <FiberManualRecord fontSize="small" sx={{ color: 'secondaryBlue.500' }} />
        <FiberManualRecord fontSize="small" sx={{ color: '#C5C7C3' }} />
      </Stack>
      <Stack direction="row" gap={3} justifyContent="flex-end">
        <CustomButton onClick={() => setIsOpen(false)} variant="secondary">
          {t('common.cancel')}
        </CustomButton>
        <CustomButton onClick={handleReject} variant="primary">
          {t('common.confirm')}
        </CustomButton>
      </Stack>
    </Stack>
  );
};

export default RejectFirstStep;
